import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../../controllers/cms/articles";
import { fetchIpAddress } from "../../../controllers/API";
import imageCompression from "browser-image-compression";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";
import ReactQuill from 'react-quill';
import { S3_BASE_URL } from "../../../config/constants";
import "./addEditData.css";

const MAX_GALLERY_IMAGES = 10;
const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

// The API re-encodes everything to WebP on upload; this just keeps the upload
// itself small (phone photos are often 5-10MB each).
const compressForUpload = (file) =>
  imageCompression(file, {
    maxSizeMB: 2,
    maxWidthOrHeight: 2400,
    useWebWorker: true,
  });

// Stored as "YYYY-MM"; older records have a full "YYYY-MM-DD"
const toMonthValue = (postedDate) => (postedDate ? String(postedDate).slice(0, 7) : "");

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(["early", "primary", "middle", "senior"]);
  // const [fileList, setFileList] = useState([]);
  const [uploadedImgs, setUploadedImgs] = useState(false);
  const [existingGallery, setExistingGallery] = useState(
    state?.gallery ? [...state.gallery] : []
  );
  const [galleryFiles, setGalleryFiles] = useState([]);
  const galleryRemaining =
    MAX_GALLERY_IMAGES - existingGallery.length - galleryFiles.length;
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const [pagesAddEditData, setPagesAddEditData] = useState([]);
  const handlePagesChange = (value) => {
    setPagesAddEditData(value);
    setError((preError) => ({
      ...preError,
      page: "",
    }));
  };

  const pagesOptions = pages.map((page) => ({
    value: page,
    label: page,
  }));

  // const handleSectionChange = (index, field, value, type) => {
  //   const updatedSection = [...ADDEDITDATA[type]];
  //   updatedSection[index][field] = value;
  //   setAddEditSata({ ...ADDEDITDATA, [type]: updatedSection });
  // };
  const handleSectionChange = (index, field, value) => {
    const updatedSection = [...ADDEDITDATA.sections];
    updatedSection[index][field] = value;
    setAddEditSata({ ...ADDEDITDATA, sections: updatedSection });
    // console.log('updatedSection', updatedSection);
  };

  const addSections = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      sections: [
        ...(ADDEDITDATA.sections || []),
        { title: "", subtitle: "", content: "" },
      ],
    });
  };
  const removeSection = (index) => {
    const updatedSections = [...ADDEDITDATA.sections];
    updatedSections.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, sections: updatedSections }));
  };



   /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
   const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, image: "Please upload a valid image file." }));
      return;
    }

    if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
      setError((prev) => ({ ...prev, image: "Please upload a JPG, PNG or WebP image." }));
      return;
    }

    try {
      const compressedFile = await compressForUpload(file);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setImage([newFile]);
      setError((prev) => ({ ...prev, image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file) => {
    setImage([]); // Clear the image
    // message.success("Image removed successfully!");
  };

  /*********************************************************
   *  Gallery: new files are compressed on save, not on pick
   *********************************************************/
  const handleGalleryChange = ({ fileList }) => {
    const valid = fileList.filter((f) =>
      ACCEPTED_IMAGE_TYPES.includes((f.originFileObj || f).type)
    );
    const allowed = MAX_GALLERY_IMAGES - existingGallery.length;
    let message = "";
    if (valid.length < fileList.length) {
      message = "Only JPG, PNG or WebP images can be added (export iPhone HEIC photos as JPG first).";
    } else if (valid.length > allowed) {
      message = `A story can have at most ${MAX_GALLERY_IMAGES} gallery photos; the extra ones were left out.`;
    }
    setGalleryFiles(valid.slice(0, allowed));
    setError((prev) => ({ ...prev, gallery: message }));
  };

  const removeExistingGalleryImage = (path) => {
    setExistingGallery((prev) => prev.filter((p) => p !== path));
    setError((prev) => ({ ...prev, gallery: "" }));
  };
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        title,
        content,
        type,
        author,
        posted_date,
        sections,
        tags,
        metaTitle,
        metaKeywords,
        metaDescription
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("title", title);
      form.append("content", content);
      form.append("type", type);
      form.append("author", author);
      form.append("posted_date", toMonthValue(posted_date));
      form.append("pages", JSON.stringify(pagesAddEditData));
      form.append("tags", tags);
      form.append("sections", JSON.stringify(sections) || []);
      form.append("metaTitle", metaTitle);
      form.append("metaKeywords", metaKeywords);
      form.append("metaDescription", metaDescription);
      if (image.length > 0) {
        form.append("image", image[0]?.originFileObj);
      }
      form.append("existing_gallery", JSON.stringify(existingGallery));
      for (const galleryFile of galleryFiles) {
        const compressed = await compressForUpload(galleryFile.originFileObj);
        form.append("gallery", compressed, galleryFile.name);
      }
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: "cms/articles/addeditdata",
          postData: form,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/articles");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("title").trim() || form.get("title").trim() === "undefined" || form.get("title").trim() === null) {
      setError((preError) => ({
        ...preError,
        title: "Title is required",
      }));
      return false;
    }
    if (!form.get("content").trim() || form.get("content").trim() === "undefined" || form.get("content").trim() === null) {
      setError((preError) => ({
        ...preError,
        content: "Content is required",
      }));
      return false;
    }
    if (!form.get("type") || form.get("type") === "undefined" || form.get("type") === null) {
      setError((preError) => ({
        ...preError,
        type: "Type is required",
      }));
      return false;
    }
    if (!form.get("author").trim() || form.get("author").trim() === "undefined" || form.get("author").trim() === null) {
      setError((preError) => ({
        ...preError,
        author: "Author is required",
      }));
      return false;
    }
    if (!form.get("posted_date").trim() || form.get("posted_date").trim() === "undefined" || form.get("posted_date").trim() === null) {
      setError((preError) => ({
        ...preError,
        posted_date: "Event month is required",
      }));
      return false;
    }
    if (!form.get("metaTitle").trim() || form.get("metaTitle").trim() === "undefined" || form.get("metaTitle").trim() === null) {
      setError((preError) => ({
        ...preError,
        type: "Meta title is required",
      }));
      return false;
    }
    if (!form.get("metaDescription").trim() || form.get("metaDescription").trim() === "undefined" || form.get("metaDescription").trim() === null) {
      setError((preError) => ({
        ...preError,
        type: "Meta description is required",
      }));
      return false;
    }
    if (!ADDEDITDATA?._id && (!form.get("image") || form.get("image") == null)) {
      setError((preError) => ({
        ...preError,
        image: "Image is required",
      }));
      return false;
    }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    if (ADDEDITDATA?._id) {
      setPagesAddEditData(ADDEDITDATA?.pages);
      // console.log(ADDEDITDATA?.page);
      setUploadedImgs(true);
    }
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Story`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Story
            </h5>
          </div>
          <Link to="/cms/articles">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="title"
                      className="form-control store_input_field"
                      id="title"
                      value={ADDEDITDATA?.title}
                      onChange={handleChange}
                    />
                    {error.title ? (
                      <p style={{ color: "red" }}>
                        {error.title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="content"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Content :
                    </label>
                    <textarea
                      title="Enter content"
                      placeholder="Enter content"
                      type="text"
                      name="content"
                      className="form-control store_input_field"
                      id="content"
                      value={ADDEDITDATA?.content}
                      onChange={handleChange}
                      rows={5}
                    />
                    {error.content ? (
                      <p style={{ color: "red" }}>{error.content}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                    <label for="type" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Type</label>
                    <select className="form-control categories_select_tg_enter_product mt-2" name='type' id='type' onChange={handleChange}>
                      <option value="">Select article type</option>
                      <option value='Events' selected={ADDEDITDATA?.type === 'Events' ? true : false}>Events</option>
                      <option value='News' selected={ADDEDITDATA?.type === 'News' ? true : false}>News</option>
                    </select>
                    {error.type ? (<p style={{ color: "red" }}> {error.type} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label
                      htmlFor="author"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Author :{" "}
                    </label>
                    <input
                      title="Enter author"
                      placeholder="Enter author"
                      type="text"
                      name="author"
                      className="form-control store_input_field"
                      id="author"
                      value={ADDEDITDATA?.author}
                      onChange={handleChange}
                    />
                    {error.author ? (
                      <p style={{ color: "red" }}>
                        {error.author}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <label
                      htmlFor="posted_date"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Event Month :{" "}
                    </label>
                    <input
                      title="Month and year the event took place"
                      type="month"
                      name="posted_date"
                      className="form-control store_input_field"
                      id="posted_date"
                      value={toMonthValue(ADDEDITDATA?.posted_date)}
                      onChange={handleChange}
                    />
                    {error.posted_date ? (
                      <p style={{ color: "red" }}>
                        {error.posted_date}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <hr></hr>
                    <button type="button" onClick={addSections} className="btn btn-primary">Add Section</button>
                  </div>
                  {ADDEDITDATA?.sections?.map((section, section_index) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={section_index}>
                      <div className="row">
                        <div className="form-group col-lg-9 col-md-9-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Title :{" "}
                          </label>
                          <input
                            placeholder="Title"
                            value={section?.title}
                            onChange={(e) =>
                              handleSectionChange(section_index, "title", e.target.value)
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeSection(section_index)} className="btn btn-primary">Remove Section</button>
                        </div>
                        <div className="form-group col-lg-9 col-md-9-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Sub Title :{" "}
                          </label>
                          <input
                            placeholder="Sub Title"
                            value={section?.subtitle}
                            onChange={(e) =>
                              handleSectionChange(section_index, "subtitle", e.target.value)
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-9 col-md-9-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Content:{" "}
                          </label>
                          <div className="term_and_condation_react_quilllll">
                            <ReactQuill
                              theme="snow"
                              value={section?.content || ''}
                              // onChange={setContent}
                              onChange={(value) =>
                                handleSectionChange(section_index, "content",value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <hr></hr>
                    </div>
                  ))}



                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <label htmlFor="pages" className="all_lebel_margin_top_main_div"><span style={{ color: "red" }}>*</span>Select pages : </label>
                    <Select
                      mode="multiple"
                      placeholder="Select pages"
                      variant="pages"
                      name="pages"
                      className="form-control store_input_field"
                      style={{ flex: 1 }}
                      value={pagesAddEditData}
                      onChange={handlePagesChange}
                      options={pagesOptions}
                    />
                    {error.pages ? (
                      <p style={{ color: "red" }}>{error.pages}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <label
                      htmlFor="tags"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Tags (Separate tags with commas) :
                    </label>
                    <textarea
                      title="Enter tags"
                      placeholder="Enter tags"
                      type="text"
                      name="tags"
                      className="form-control store_input_field"
                      id="tags"
                      value={ADDEDITDATA?.tags}
                      onChange={handleChange}
                    />
                    {error.tags ? (
                      <p style={{ color: "red" }}>{error.tags}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
                    <label
                      htmlFor="metaTitle"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Meta title :
                    </label>
                    <textarea
                      title="Enter meta title"
                      placeholder="Enter meta title"
                      type="text"
                      name="metaTitle"
                      className="form-control store_input_field"
                      id="metaTitle"
                      value={ADDEDITDATA?.metaTitle}
                      onChange={handleChange}
                    />
                    {error.metaTitle ? (
                      <p style={{ color: "red" }}>{error.metaTitle}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="metaKeywords"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                    Meta keywords :
                    </label>
                    <textarea
                      title="Enter meta keywords"
                      placeholder="Enter meta keywords"
                      type="text"
                      name="metaKeywords"
                      className="form-control store_input_field"
                      id="metaKeywords"
                      value={ADDEDITDATA?.metaKeywords}
                      onChange={handleChange}
                    />
                    {error.metaKeywords ? (
                      <p style={{ color: "red" }}>{error.metaKeywords}</p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="metaDescription"
                      className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Meta description :
                    </label>
                    <textarea
                      title="Enter meta description"
                      placeholder="Enter meta description"
                      type="text"
                      name="metaDescription"
                      className="form-control store_input_field"
                      id="metaDescription"
                      value={ADDEDITDATA?.metaDescription}
                      onChange={handleChange}
                    />
                    {error.metaDescription ? (
                      <p style={{ color: "red" }}>{error.metaDescription}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Header Image (also used as the story's thumbnail)
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    listType="picture-card"
                    onChange={handleImageChange}
                    fileList={image}
                    beforeUpload={() => false} // Prevent automatic upload
                    onRemove={handleRemove} 
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>

                  { uploadedImgs && ADDEDITDATA?.image ? (
                  <div className="container mt-2">
                    <img className="uploadedImg" src={S3_BASE_URL + ADDEDITDATA.image} alt="Current header" />
                  </div>
                  ) : null }
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG/WebP).
                  </p>
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-group article_gallery_field">
                  <label className="all_section_for_label_main_class">
                    Gallery Photos (optional, up to {MAX_GALLERY_IMAGES})
                  </label>
                  <p className="article_gallery_hint">
                    Shown on the story page as a photo grid that opens in a
                    lightbox. Photos are compressed and converted to WebP
                    automatically when you save.
                  </p>

                  {existingGallery.length > 0 && (
                    <div className="article_gallery_existing">
                      {existingGallery.map((path, index) => (
                        <div className="article_gallery_existing_item" key={path}>
                          <img src={S3_BASE_URL + path} alt={`Gallery ${index + 1}`} />
                          <button
                            type="button"
                            className="article_gallery_remove"
                            onClick={() => removeExistingGalleryImage(path)}
                            title="Remove this photo"
                            aria-label={`Remove gallery photo ${index + 1}`}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {galleryRemaining > 0 || galleryFiles.length > 0 ? (
                    <Dragger
                      className="about_us_dragger_file"
                      multiple
                      accept={ACCEPTED_IMAGE_TYPES.join(",")}
                      listType="picture-card"
                      onChange={handleGalleryChange}
                      fileList={galleryFiles}
                      beforeUpload={() => false} // Uploaded with the form on Save
                      disabled={galleryRemaining <= 0}
                    >
                      <button
                        type="button"
                        className="about_us_dragger_file_button"
                        disabled={galleryRemaining <= 0}
                      >
                        {galleryRemaining > 0
                          ? `Add photos (${galleryRemaining} more allowed)`
                          : "Gallery is full"}
                      </button>
                    </Dragger>
                  ) : (
                    <p className="article_gallery_hint">
                      The gallery is full. Remove a photo to add another.
                    </p>
                  )}
                  {error.gallery ? (
                    <p style={{ color: "red" }}>{error.gallery}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
